import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import { SubCategoryDTO,CategoryDTO, BrandDTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';

@Injectable()
export class brandService implements OnInit {
    public Source:LocalDataSource;

    constructor(private http: HttpClient,private notifcationService:NotificationService) {
        this.Source = new LocalDataSource();
    }

    getBrands():any{
       return this.http.get<BrandDTO[]>(environment.apiUrl + "/Brand")
       .pipe(
        catchError(this.handleError)
       );
    }

    addBrand(brandDTO:BrandDTO){
        return this.http.post(environment.apiUrl + "/Brand", brandDTO).subscribe(
            data => {
                this.notifcationService.showSuccess("Brand", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Brand", "ajout avec success");
                console.error(error);
            }
        );



    }

    updateBrand(Brand: BrandDTO) {

        return this.http.put(environment.apiUrl + "/Brand", Brand).subscribe(
            data => {
                this.notifcationService.showSuccess("Brand", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Brand", "ajout avec success");
                console.error(error);
            }
        );

    }

    

    deleteBrand(idBrand:number){
        this.http.delete<any>(environment.apiUrl + "/Brand/"+idBrand).subscribe(
            data => {
                this.notifcationService.showSuccess("Brand", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Brand", "suppression avec success");
                console.error(error);
            }
        );
    }



    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
      };



}